
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
    ErrorGeneral: () => import('@/views/Errors/ErrorGeneral.vue'),
  },
})
export default class NotFound extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop({default: true}) backToHome!: boolean;
}
